export default __webpack_public_path__ + "static/ambetter-56b1a575165d0a550711fa67b4ce9e58.svg";